module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUBJREFUOE+1kz9IQmEUxX9XsyJaawiXaAikhp79gaK9QKIhMLVyCZqbG1qiramhIaKh/FprioYIIXIovyEol7CpxRosIijyfaEiT5DEZ3S3w+X+OOfAFQATsdYQ1gFfUf8yOZB5UemL6r2UAFHL1DmsWsmdqPRA8wAhIwkdaB4Al6L05F8AeZAk2M94C5tycPvosgM+gAzQj+FVjrS/FjA4BoFRx+X1OWTvy1q4koSeMBFrCuFUlJZaQGgJphccwOEWpM4q+kaUHjHRoUWQfVG6xW2EtCg9bGLBOMbs/ROgqwe6/U6EpyzkXyq6AQezyzC3UmoMDOxuQPLEBcDXCh2djoP3Nyh8uwDUf4qUKD1uYlYIw3GpRBMO9uE1D409Ezk8njC2PQOsYtu9YqLWNhAH2gBvHdBnuRTagWKmLww7P264oMvlUODRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jggl-1.png
// module id = lyVr
// module chunks = 7